import {Component, Inject, OnInit} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {File, Folder, Mutation} from '../types-repository';
import {Apollo, gql} from 'apollo-angular';
import {FILE_FOLDER_LIST_WITH_ARCHIVE} from '../queries-repository';
import { DatePipe } from '@angular/common';
import {DoButtonComponent} from '../components/do-button/do-button.component';
import {MessageFieldComponent} from '../components/do-button/message-field.component';
import {CldatePipe} from '../pipes/cldate.pipe';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
  imports: [DoButtonComponent, MessageFieldComponent, CldatePipe],
})
export class DeleteDialogComponent implements OnInit {
  protected basedir: Folder;
  protected items: (File | Folder)[];

  constructor(public dialogRef: DialogRef<string>,
              @Inject(DIALOG_DATA) public data: { basedir: Folder, items: (File | Folder)[] },
              private apollo: Apollo) {
    this.basedir = data.basedir;
    this.items = data.items;
  }

  ngOnInit(): void {
  }

  performDelete(btn: DoButtonComponent): void {
    const files = this.items.filter((item): item is File => item.__typename === 'File');
    const folders = this.items.filter((item): item is Folder => item.__typename === 'Folder');

    const buildMutation = (items: (File | Folder)[]) =>
    gql`mutation BatchDelete {
      ${items.map((item, index) => `del${index}: delete(input: {id: "${item.id}"}) {
        file {
          id
        }
      }`).join('\n')}
    }`;

    const deleteItems = (items: (File | Folder)[], onSuccess: () => void) => {
      if (items.length === 0) {
        onSuccess();
        return;
      }

      this.apollo.mutate<Mutation>({
        mutation: buildMutation(items),
        refetchQueries: [{
          query: FILE_FOLDER_LIST_WITH_ARCHIVE,
          variables: {
            show_deleted: true,
            id: this.basedir.id
          },
        }]
      }).subscribe({
        next: () => onSuccess(),
        error: err => btn.done(err.message),
      });
    };

    deleteItems(files, () => deleteItems(folders, () => this.dialogRef.close()));
  }
}
